// Aprendizado da IA — textos legíveis para códigos do backend (rodada noturna, descartes, motivos).
import { i18n } from "../../translate/i18n";

export const fmtPct = (ratio) => {
  const n = Number(ratio);
  if (ratio == null || !Number.isFinite(n)) return "—";
  return `${Math.round(n * 100)}%`;
};

const has = (key) => i18n.exists(key);

/** skippedReason do backend → frase. Aceita `extraction_<motivo>`; código desconhecido sai cru. */
export const skippedText = (code) => {
  if (!code) return "";
  const raw = String(code);
  if (raw.startsWith("extraction_")) {
    const inner = raw.slice("extraction_".length);
    const key = `aiLearning.skipped.${inner}`;
    return i18n.t("aiLearning.skipped.extractionPrefix", { reason: has(key) ? i18n.t(key) : inner });
  }
  const key = `aiLearning.skipped.${raw}`;
  return has(key) ? i18n.t(key) : raw;
};

export const discardText = (code) => {
  const key = `aiLearning.discard.${code}`;
  return has(key) ? i18n.t(key) : String(code);
};

/** motivo do resultado: códigos do sistema são traduzidos; texto livre da IA passa como veio */
export const reasonText = (reason) => {
  const raw = String(reason || "");
  if (!/^[a-z0-9_]+$/.test(raw)) return raw;
  const key = `aiLearning.reasons.${raw}`;
  return has(key) ? i18n.t(key) : raw;
};

/** linhas do resumo da última execução */
export const lastRunLines = (run) => {
  if (!run) return [];
  const lines = [];
  const n = (v) => Number(v) || 0;
  lines.push(
    i18n.t("aiLearning.lastRun.summary", {
      evaluated: n(run.evaluated),
      created: n(run.created),
      reinforced: n(run.reinforced),
      discarded: n(run.discarded),
      memories: n(run.memories),
    })
  );
  const by = run.discardedBy && typeof run.discardedBy === "object" ? Object.entries(run.discardedBy) : [];
  const list = by
    .filter(([, c]) => n(c) > 0)
    .sort((a, b) => n(b[1]) - n(a[1]))
    .map(([k, c]) => `${discardText(k)} (${n(c)})`)
    .join(", ");
  if (list) lines.push(i18n.t("aiLearning.lastRun.discardedBy", { list }));
  const cost = Number(run.costBrl);
  if (run.costBrl != null && Number.isFinite(cost)) {
    const value = cost.toLocaleString("pt-BR", { style: "currency", currency: "BRL", minimumFractionDigits: 2, maximumFractionDigits: 4 });
    lines.push(i18n.t("aiLearning.lastRun.cost", { value }));
  }
  if (run.skippedReason) lines.push(i18n.t("aiLearning.lastRun.skipped", { reason: skippedText(run.skippedReason) }));
  return lines;
};
